<!--  


<div class="container-scroller">
    <app-top-bar>

    </app-top-bar>
<div class="container-fluid page-body-wrapper">


             <app-right-sidebar>

              </app-right-sidebar>
             <app-sidemenus>

            </app-sidemenus>
            <app-new-contract>

            </app-new-contract>
 
</div>
</div> -->

<app-new-contract></app-new-contract>